// extracted by mini-css-extract-plugin
export default {"article":"HowItWorks_article__Dsp5E","header":"HowItWorks_header__VD7+s"};